import { render, staticRenderFns } from "./itensDre.vue?vue&type=template&id=2a35a1a2&scoped=true&"
import script from "./itensDre.vue?vue&type=script&lang=js&"
export * from "./itensDre.vue?vue&type=script&lang=js&"
import style0 from "./itensDre.vue?vue&type=style&index=0&id=2a35a1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35a1a2",
  null
  
)

export default component.exports